export const serviceOpsFollowupConstants = {
    LOADING: 'SERVICEOPS_LOADING',
    COMMENTS_LOADING: 'SERVICEOPS_COMMENTS_LOADING',
    UPDATE_FOLLOWUP_TABLE: 'SERVICEOPS_UPDATE_FOLLOWUP_TABLE',
    ERROR: 'SERVICEOPS_ERROR',
    CLOSE_MODAL: 'SERVICEOPS_CLOSE_MODAL',
    UPDATE_COMMENT_VALUE: 'SERVICEOPS_FOLLOWUP_UPDATE_COMMENT_VALUE',
    UPDATE_SHIPMENT_COMMENTS: 'SERVICEOPS_UPDATE_SHIPMENT_COMMENTS',
    UPDATE_SELECTED_SHIPMENT_COMMENTS_AND_STATUSES: 'SERVICEOPS_UPDATE_SELECTED_SHIPMENT_COMMENTS_AND_STATUSES',
    UPDATE_SELECTED_SHIPMENT_MAIL_TEMPLATES: 'SERVICEOPS_UPDATE_SELECTED_SHIPMENT_MAIL_TEMPLATES',
    UPDATE_MAIL_TEMPLATE: 'SERVICEOPS_UPDATE_MAIL_TEMPLATE',
    UPDATE_MAIL_VALUE: 'SERVICEOPS_UPDATE_MAIL_VALUE'
};